import estyled from '@signal/theme/emotion'
import {
  getSpacingSelector,
  getColorBackgroundSelector,
  getColorTextSelector
} from '@signal/theme/selectors'
import Typography from '../Typography'
import { ecss } from '@signal/theme/emotion'

const gridSpacingSelector = getSpacingSelector(1.75)

export const Wrapper = estyled.div`
  background: ${getColorBackgroundSelector('paper')};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  && {
    padding: ${getSpacingSelector(10)}px 0;
  }
`

export const Grid = estyled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  grid-gap: ${gridSpacingSelector}px;
  margin: ${gridSpacingSelector}px;
  max-width: 620px;
`

export const Description = estyled(Typography).attrs(() => ({
  variant: 'subtitle1',
  align: 'center'
}))``

export const Title = estyled(Typography).attrs(() => ({
  variant: 'h3',
  align: 'center'
}))``

export const Icon = estyled.img`
  justify-self: center;
  color: ${props => props.iconColor || getColorTextSelector()(props)};
  font-size: 60px;
`

export const Image = estyled.img`
  height: auto;
  justify-self: center;
  width: 454px;
  padding-bottom: 20px;

  ${({ $isDarkMode }) => {
    if ($isDarkMode) {
      return ecss`
        filter: invert(1) brightness(70%) grayscale();
      `
    }
  }}
`
